var App = App || {};

App.AlertsAccessibility = (function () {
    var lastActiveElement;

    return {
        init: init
    };

    function init() {
        initializeAlertsAccessibility();
    }

    function initializeAlertsAccessibility() {
        var $modal = $('.js-content-alert-modal, .js-alert-resources-modal-list, .js-alert-resources-modal, .js-activity-modal');
        if ($modal.length) {
            $modal.on('opened.fndtn.reveal', openAlertModal); 
            $modal.on('closed.fndtn.reveal', closeAlertModal);
        }
    }

    function openAlertModal() {
        var $modal = $(this);
        if ($modal.length) {
            lastActiveElement = document.activeElement;
            SCM.trapFocus.publicTrapFocus($modal, $modal.find('.js-close-reveal-modal'), lastActiveElement);
            setAriaExpandedAttributes($modal, true);
            focusFirstActiveElement($modal);
        }
    }

    function closeAlertModal() {
        var $modal = $(this);
        setAriaExpandedAttributes($modal, false);
        if (lastActiveElement) {
            lastActiveElement.focus();
        }
    }

    function focusFirstActiveElement($modal) {
        var visibleElements = SCM.trapFocus.getModalVisibleAndFocusableElements($modal);
        if (visibleElements.length > 0) {
            var firstFocusableElement = visibleElements[0];
            firstFocusableElement.focus();
        }
    }


    function setAriaExpandedAttributes($modal, isModalOpen) {
        $modal.attr('aria-expanded', isModalOpen);
        if (lastActiveElement) {
            $(lastActiveElement).attr('aria-expanded', isModalOpen);
        }
    }
})(jQuery);